import { memo } from 'react';

import type { Props } from './TranslationNodeAttribute.types';

import style from './TranslationNodeText.module.css';

export const TranslationNodeAttribute = memo<Props>(({ node }) => {
  return <div className={style.node}>{node.value}</div>;
});
